const restrictedStates = {
  AR: {
    id: 0,
    name: 'AR',
  },
};

export default restrictedStates;



// WEBPACK FOOTER //
// ./src/data/static/restrictedStates.js